import React, { createContext, useContext, useReducer } from "react";

// Initial state - essenziale per auth, tenants e keys
const initialState = {
  // Authentication
  authToken: null,
  userActions: [],
  // Tenant state
  tenants: [],
  selectedTenant: null,

  // data state
  keys: [],
  selectedKey: null,
  selectedValue: null,
  isLoadingKeys: false,
  isLoadingValue: false,
  keysError: null,
  valueError: null,
};

// Action types ridotti alle azioni effettivamente utili
export const AppActionTypes = {
  SET_AUTH_TOKEN: "SET_AUTH_TOKEN",
  SET_USER_ACTIONS: "SET_USER_ACTIONS",
  SET_TENANTS: "SET_TENANTS",
  SET_SELECTED_TENANT: "SET_SELECTED_TENANT",
  SET_KEYS: "SET_KEYS",
  SET_SELECTED_KEY: "SET_SELECTED_KEY",
  SET_SELECTED_VALUE: "SET_SELECTED_VALUE",
  SET_LOADING_KEYS: "SET_LOADING_KEYS",
  SET_LOADING_VALUE: "SET_LOADING_VALUE",
  SET_KEYS_ERROR: "SET_KEYS_ERROR",
  SET_VALUE_ERROR: "SET_VALUE_ERROR",
};

// Reducer semplificato
function appReducer(state, action) {
  switch (action.type) {
    case AppActionTypes.SET_AUTH_TOKEN:
      return { ...state, authToken: action.payload };

    case AppActionTypes.SET_USER_ACTIONS:
      return { ...state, userActions: action.payload };

    case AppActionTypes.SET_TENANTS:
      return { ...state, tenants: action.payload };

    case AppActionTypes.SET_SELECTED_TENANT:
      return { ...state, selectedTenant: action.payload };

    case AppActionTypes.SET_KEYS:
      return { ...state, keys: action.payload };

    case AppActionTypes.SET_SELECTED_KEY:
      return { ...state, selectedKey: action.payload };

    case AppActionTypes.SET_SELECTED_VALUE:
      return { ...state, selectedValue: action.payload };

    case AppActionTypes.SET_LOADING_KEYS:
      return { ...state, isLoadingKeys: action.payload };

    case AppActionTypes.SET_LOADING_VALUE:
      return { ...state, isLoadingValue: action.payload };

    case AppActionTypes.SET_KEYS_ERROR:
      return { ...state, keysError: action.payload };

    case AppActionTypes.SET_VALUE_ERROR:
      return { ...state, valueError: action.payload };

    default:
      return state;
  }
}

const AppContext = createContext();

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context)
    throw new Error("useAppContext must be used within an AppProvider");
  return context;
}
